<div class="aig-option__options u-ds-grid u-gap-8">
    <div class="aig-option__option p-flexcb u-bg-comp2 u-py-3 u-px-4">
        <p class="u-fw-600 u-color-primary1">Funcional</p>
        <p class="u-color-success-strong">Siempre activo</p>
    </div>
    <div class="aig-option__option p-flexcb u-bg-comp2 u-py-3 u-px-4">
        <p class="u-fw-600 u-color-primary1">Marketing</p>
        <span class="c-switch__checkbox" id="1" [class.c-switch__checkbox--on]="switchActivatedMarketing" (click)="toggleSwitchMarketing()">
        <span class="c-switch__thumb-wrap" [class.c-switch__thumb-wrap--on]="switchActivatedMarketing">
        <span class="c-switch__thumb"></span>
        </span>
        <p class="c-switch__on"></p>
        <p class="c-switch__off"></p>
        </span>
    </div>
    <div class="aig-option__option p-flexcb u-bg-comp2 u-py-3 u-px-4">
        <p class="u-fw-600 u-color-primary1">Estadísticas</p>
        <span class="c-switch__checkbox" id="2" [class.c-switch__checkbox--on]="switchActivatedStatistics" (click)="toggleSwitchStadistics()">
        <span class="c-switch__thumb-wrap" [class.c-switch__thumb-wrap--on]="switchActivatedStatistics">
            <span class="c-switch__thumb"></span>
        </span>
        <p class="c-switch__on"></p>
        <p class="c-switch__off"></p>
        </span>
    </div>
</div>
